import { useEventBus } from '@vueuse/core'
import { modalsInjectionKey } from '~/utils/modals/index'

export default defineNuxtPlugin(() => {
  const bus = useEventBus(modalsInjectionKey)

  return {
    provide: {
      modal: {
        hide: (name: string) => bus.emit('hide', { name }),
        show: (name: string) => bus.emit('show', { name }),
      },
    },
  }
})
